<template>
  <div>
    <v-dialog v-model="dialog" persistent width="700">
      <v-card>
        <v-container>
          <v-row>
            <v-col>
              <p class="text-center">
                QUESTIONNAIRE RELATIF À L'ÉTAT DE SANTÉ DU SPORTIF MINEUR EN VUE DE L'INSCRIPTION À UNE COMPÉTITION SPORTIVE AUTORISÉE PAR UNE FÉDÉRATION DÉLÉGATAIRE OU
                ORGANISÉE PAR UNE FÉDÉRATION AGRÉÉE, HORS DISCIPLINES À CONTRAINTES PARTICULIÈRES <br />(Annexe II-23, art. A. 231-3 du code du sport)
              </p>
            </v-col>
          </v-row>
          
        
          <v-divider></v-divider>
          <v-row>
            <v-col>
              <div>Répondez aux questions suivantes par OUI ou par NON<span class="text-red-darken-4">*</span></div>
              <div class="text-red-darken-4">*NB: Les réponses fomulées relèvent de la seule responsabilité du participant.</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-alert><b>Durant les 12 derniers mois</b></v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ul>
                <li class="mb-1" v-for="(item, index) in items_annee_derniere" :key="index">
                  {{ item }}
                </li>
              </ul>
            </v-col>
          </v-row>
       
      
          <v-row>
            <v-col>
              <v-alert><b>A ce jour</b></v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ul>
                <li class="mb-1" v-for="(item, index) in items_ajd" :key="index">
                  {{ item }}
                </li>
              </ul>
            </v-col>
          </v-row>
      
         
          <v-divider> </v-divider>
          <div>
            <v-btn @click="$emit('unvalidate')" color="dark-red" class="btn-multiline sm-fullwidth mb-3 py-1"> <span class="text-wrap">J'ai répondu OUI à une ou plusieurs questions</span></v-btn>
            <v-btn @click="$emit('validate')" color="dark-green" class="btn-multiline sm-fullwidth mb-3 py-1"><span class="text-wrap">J'ai répondu NON à toutes les questions</span></v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["inscription"],
  data() {
    return {
      dialog: true,
      items_annee_derniere: [
        " Un membre de votre famille est-il décédé subitement d’une cause cardiaque ou inexpliquée ?",
        "Avez-vous ressenti une douleur dans la poitrine, des palpitations, un essoufflement inhabituel ou un malaise ?",
        "Avez-vous eu un épisode de respiration sifflante (asthme) ?",
        " Avez-vous eu une perte de connaissance ?",
        "Si vous avez arrêté le sport pendant 30 jours ou plus pour des raisons de santé, avez-vous repris sans l'accord d'un médecin ?",
        "Avez-vous débuté un traitement médical de longue durée (hors contraception et désensibilisation aux allergies) ?",
      ],

      items_ajd: ["Ressentez-vous une douleur, un manque de force ou une raideur suite à un problème osseux, articulaire ou musculaire (fracture, entorse, luxation, déchirure, tendinite, etc…) survenu durant les 12 derniers mois?",
        "Votre pratique sportive est-elle interrompue pour des raisons de santé ?",
        "Pensez-vous avoir besoin d'un avis médical pour poursuivre votre pratique sportive ?"],

    };
  },
};
</script>

<style lang="scss" scoped>
.btn-multiline {
  height: auto;
}
.btn-multiline > span {
  width: 100%;
}
</style>